import { createSlice } from '@reduxjs/toolkit'

export const loaderSlice = createSlice({
  name: 'loader',
  initialState: {
    display: false,
    defaultText: 'Loading',
    text: 'Loading'
  },
  reducers: {
    show: (state, action) => {
      state.display = true
      if (action.payload) {
        state.text = action.payload
      }
    },
    hide: state => {
      state.display = false
      state.text = state.defaultText
    }
  }
})

export const { show, hide } = loaderSlice.actions

export default loaderSlice.reducer
